import {useTheme} from "@mui/material/styles"

export default function BackgroundApp() {
    const theme = useTheme()
    const PRIMARY_COLOR = theme.palette.primary.main
    const SECONDARY_COLOR = theme.palette.primary.light

    const pathSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="2000" height="80" preserveAspectRatio="none" viewBox="0 0 2000 80">'+
        '<g mask="url(&quot;#SvgjsMask1821&quot;)" fill="none">'+
        '<path d="M 0,17 C 100,20.8 300,38.4 500,36 C 700,33.6 800,4.6 1000,5 C 1200,5.4 1300,36 1500,38 C 1700,40 1900,19.6 2000,15L2000 80L0 80z" fill="{{primaryColor}}"></path>'+
        '<path d="M 0,55 C 57.2,60 171.6,82.6 286,80 C 400.4,77.4 457.6,44.8 572,42 C 686.4,39.2 743.6,65.8 858,66 C 972.4,66.2 1029.6,40.6 1144,43 C 1258.4,45.4 1315.6,76.8 1430,78 C 1544.4,79.2 1602,51.4 1716,49 C 1830,46.6 1943.2,62.6 2000,66L2000 80L0 80z" fill="{{secondaryColor}}"></path>'+
        '</g><defs><mask id="SvgjsMask1821"><rect width="2000" height="80" fill="#ffffff"></rect></mask></defs></svg>'

    const header = 'data:image/svg+xml,'
    const svgColorized = pathSVG
        .replace("{{primaryColor}}", PRIMARY_COLOR)
        .replace("{{secondaryColor}}", SECONDARY_COLOR)

    return header + encodeURIComponent(svgColorized)
}